import { LitElement, css, html } from 'lit'
import { customElement, property, query } from 'lit/decorators.js'

@customElement('ep-timeline-comment')
export class EPTimelineComment extends LitElement {

  @property({ attribute: false })
  showAttachments: boolean = false;

  @query('slot[name=attachments]')
  attachmentsSlot?: HTMLSlotElement;

  private _handleAttachmentsSlotChange(event: Event) {
    this.showAttachments = (this.attachmentsSlot?.assignedNodes()?.length ?? 0) > 0;
  }

  render() {
    return html`
      <div class="timeline-item-body-comment">
        <div class="timeline-comment-header">
          <slot name="header"></slot>
        </div>
        <div class="timeline-comment-body">
          <div class="timeline-comment-body-message">
            <slot></slot>
          </div>
          <div class="timeline-comment-body-attachments" style=${!this.showAttachments ? 'display: none;' : ''}>
            <slot name="attachments" @slotchange=${this._handleAttachmentsSlotChange}></slot>
          </div>
        </div>
      </div>
    `
  }

  static styles = css`
    :host {
      display: block;
      --text-default: rgb(31, 35, 40);
      --text-muted: rgb(101, 109, 118);
      --border-muted: rgb(216, 222, 228);
      --border-default: rgb(208, 215, 222);
      --badge-background: rgb(234, 238, 242);
      --canvas-subtle: rgb(246, 248, 250);
    }

    .timeline-item-body-comment {
      position: relative;
      color: #000000;
      background-color: #ffffff;
      border: 1px solid var(--border-default);
      border-radius: 6px;
      margin-left: -16px;
    }

    .timeline-item-body-comment::after {
      display: block;
      margin-left: 2px;
      background-color: #ffffff;
      background-image: linear-gradient(var(--canvas-subtle), var(--canvas-subtle));
    }

    .timeline-item-body-comment::after, .timeline-item-body-comment::before {
      position: absolute;
      top: 11px;
      right: 100%;
      left: -8px;
      display: block;
      width: 8px;
      height: 16px;
      pointer-events: none;
      content: " ";
      clip-path: polygon(0 50%, 100% 0, 100% 100%);
    }

    .timeline-item-body-comment::before {
      background-color: var(--border-default);
    }

    .timeline-comment-header {
      display: flex;
      align-items: center;
      padding-right: 16px;
      padding-left: 16px;
      color: var(--text-muted);
      /* flex-direction: row-reverse; */
      background-color: var(--canvas-subtle);
      border-bottom: 1px solid var(--border-default);
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      /*  */
      min-height: 36px;
      --chip-height: 18px;
    }

    .timeline-comment-header h3 {
      flex: 1 1 auto;
      margin-top: 0;
      margin-bottom: 0;
      font-weight: 400;
    }

    ::slotted([slot=header]) {
      margin-top: 0;
      margin-bottom: 0;
      /* color: var(--text-muted); */
    }
    ::slotted([slot=header]>strong) {
      color: red;
    }

    .timeline-comment-body-message {
      padding: 16px;
    }
    
    .timeline-comment-body-message > :first-child {
      margin-top: 0;
    }

    .timeline-comment-body-message > :last-child {
      margin-bottom: 0;
    }

    ::slotted([slot=body]) {
      margin-top: 0;
      margin-bottom: 0;
    }

    .timeline-comment-body-attachments {
      display: flex;
      flex-wrap: wrap;
      padding-left: 16px;
      padding-bottom: 16px;
      gap: 8px;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-timeline-comment': EPTimelineComment
  }
}
